module.exports = __webpack_public_path__ + "media/images/logo-ca7575b19036744a6946f88ecc525e0f.png";